import styled from "styled-components";

import type { StrictColor } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import type { StatusChipType } from "./types";

export const STATUS_CHIP_LOADER_OPTIONS = {
    style: { width: 16, height: 16 },
    svg: { cx: "50%", cy: "50%", r: "6", strokeWidth: "1", fill: "none" },
};

export const COLOR_BY_CHIP_TYPE: Record<StatusChipType, StrictColor> = {
    success: colorsPalettes.mint["500"],
    warning: colorsPalettes.orange["500"],
    error: colorsPalettes.red["500"],
    neutral: colorsPalettes.carbon["200"],
};

export const StyledStatusChip = styled(Flex)<{ type: StatusChipType }>`
    gap: 4px;
    align-items: center;
    flex-shrink: 0;
    white-space: nowrap;
    border-radius: 20px;
    border: 1px solid ${({ type }) => COLOR_BY_CHIP_TYPE[type]};
    padding: 2px 5px;

    & > svg {
        margin-left: -2px;
    }
`;

export const StyledStatusChipLoaderWrapper = styled(Flex)<{ type: StatusChipType }>`
    width: 16px;
    height: 16px;

    & > svg {
        stroke: ${({ type }) => COLOR_BY_CHIP_TYPE[type]};
    }
`;
